import { createSlice } from "@reduxjs/toolkit";

const languageSlice = createSlice({
  name: "language",
  initialState: "en",
  reducers: {
    setLanguage(state = "", action) {
      return action.payload || state;
    },
  },
});

export const { setLanguage } = languageSlice.actions;

export default languageSlice.reducer;
